var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-property"},[_c('div',{staticClass:"editor-property-title"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"editor-property-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }